import React, { useEffect, useState } from 'react'
import DetalleEnHistograma from './DetalleEnHistograma'
import { Typography } from '@material-ui/core'

export default function DemorasPorHoraEnVolcadora (props) {
  const { demorasPorHora, value } = props
  const [tooltipText, setTooltipText] = useState('')

  useEffect(() => {
    const demorasVolcadora = []
    if (demorasPorHora.length > 0) {
      demorasPorHora.map((demora) => {
        const dem = ({
          motivo: demora.motivoDeDemora,
          duracion: demora.duracion,
          volcadora: demora.volcadoraCamiones
        })
        return demorasVolcadora.push({ demora: dem })
      })
    }

    const text = demorasVolcadora.length > 0 &&
            demorasVolcadora.map((d, i) => (
              <Typography key={i} variant='caption' display='block'>
                Duración: {d.demora.duracion} - {d.demora.motivo}
              </Typography>
            ))
    setTooltipText(text)
  }, [demorasPorHora, setTooltipText])

  return (
    <DetalleEnHistograma
      tooltipText={tooltipText}
      value={value}
    />
  )
}
